export default "__VITE_ASSET__D9r8yuk6__"